export const cardPage = {
    "cvv": "CVV",
    "expiry": "Expiry",
    "card_number": "Card number",
    "future_charge": "Your first charge will be at {{date}}",
    "total_payable": "Total payable",
    "payment_provider_error": "Payment provider internal error",
    "payment_error": "Payment error, please try again",
};
